import styled, { css } from 'styled-components';

export const NavIcon = styled.button<{
  $useShadow?: boolean;
  $shadowColor?: string;
  $hasHover?: boolean;
  $disableMaxHeight?: boolean;
}>`
  display: flex;
  border: none;
  background: none;
  padding: 0;
  position: relative;
  align-items: center;
  justify-content: center;
  height: auto;
  width: auto;
  line-height: 1;

  .base-img {
    display: block;
    width: auto;
    height: auto;
    max-height: ${({ $disableMaxHeight }) => ($disableMaxHeight ? 'none' : 'var(--menuImgMaxHeight, auto)')};
    max-width: 100%;
    object-fit: contain;
    object-position: center center;
    transition: opacity 0.25s ease;
    will-change: opacity;
    backface-visibility: hidden;
  }

  .hover-img {
    position: absolute;
    inset: 0;
    opacity: 0;
    pointer-events: none;
    width: 100%;
    height: 100%;
    max-height: ${({ $disableMaxHeight }) => ($disableMaxHeight ? 'none' : 'var(--menuImgMaxHeight, auto)')};
    max-width: 100%;
    object-fit: contain;
    object-position: center center;
    transition: opacity 0.25s ease;
    will-change: opacity;
    backface-visibility: hidden;
  }

  ${({ $hasHover }) =>
    $hasHover &&
    css`
      &:hover .hover-img {
        opacity: 1;
      }
      &:hover .base-img {
        opacity: 0;
      }
    `}
`;

// menuTextType에 따른 이미지 정렬 스타일 맵
export const imageAlignmentStyles = {
  left: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  right: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
} as const;
